module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 

var group = function () {
    return groups.find(function (g) {
        return g['value'] === groupBy;
    }) || {};
};

var groupTitles = function () {
    return group()['groupTitle'];
};

var groupTitle = function (level) {
    return groupTitles()[level];
};
var subLength = function (arr) {
    var len = 0;
    arr.forEach(function (row) {
        len+=row.length;
    })
    return len;
}

var toHectare = function (value) {
    if (value == null || value === '') {
        return '';
    }

    return _.round(value / 10000, 0);
};

var numFormat = function (num) {
    if (num && num.length)
        num = num.replace('.',',');
    return num;
}

    ; __append("\n")
    ;  var showDataCells = function (row, tag, i) {
    tag = tag || 'td'; 
    ; __append("\n\n<")
    ; __append(escapeFn( tag ))
    ; __append(" style=\"white-space: nowrap;\">")
    ; __append(escapeFn( i ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append( row.name ? row.name : row.landuser_name ? row.landuser_name : "<i>не указан</i>")
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn(  _.round(row.dist_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( _.round(row.owned_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( _.round(row.gov_rent_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( _.round(row.municipal_rent_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( _.round(row.common_rent_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( _.round(row.subrent_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( _.round(row.confidence_use_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( _.round(row.permanent_use_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( _.round(row.lifelong_use_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( _.round(row.farm_use_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( _.round(row.actual_use_area, 2) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n    ")
    ;  } 
    ; __append("\n\n\n<style>\n    .gl-report__table {\n        border-spacing  : 0;\n        border-collapse : collapse;\n        table-layout: auto;\n    }\n</style>\n\n<div class=\"wh100\">\n    <div class=\"cell__abs_container\">\n        <div class=\"cell__abs overflow-y__auto\">\n            <table class=\"w100 gl-striped__table gl-report__table\">\n                <thead>\n                <tr>\n                    ")
    ;  for (var i=0; i<groupTitles().length; i++) {
    ; __append("\n                        <td >")
    ; __append(escapeFn( groupTitle(i) ))
    ; __append("</td>\n                    ")
    ;  } 
    ; __append("\n                    <td rowspan=\"3\">п/п</td>\n                    <td rowspan=\"3\">")
    ; __append(escapeFn( (groupBy === 'dist') ? 'Район' : 'Наименование СХТП'))
    ; __append("</td>\n                    <td rowspan=\"3\">Общая площадь, га</td>\n                    <td colspan=\"10\">Право использования земельного участка, га.</td>\n                </tr>\n                <tr>\n                    <td rowspan=\"2\">Собственность</td>\n                    <td colspan=\"4\">Аренда</td>\n                    <td colspan=\"5\">Пользование</td>\n                </tr>\n                <tr>\n                    <!-- Аренда -->\n                    <td>Государственной собственности</td>\n                    <td>Муниципальной собственности</td>\n                    <td>Общедолевой собственности</td>\n                    <td>Субаренда</td>\n                    <!-- Пользование -->\n                    <td>Доверительное управление</td>\n                    <td>Постоянное (бессрочное) пользование</td>\n                    <td>Пожизненное наследуемое владение</td>\n                    <td>Хозяйственное ведение</td>\n                    <td>Фактическое (без документов)</td>\n                </tr>\n                </thead>\n                <tbody>\n\n\n                ")
    ;  data.rows.forEach(function (row, i) { 
    ; __append("\n                <tr>\n                    ")
    ; showDataCells(row, 'td', i + 1)
    ; __append("\n                </tr>\n                ")
    ; })
    ; __append("\n                <tr>\n                    ")
    ;  data.total.name = 'Итог'; 
    ; __append("\n                    ")
    ;  showDataCells(data.total, 'td', '')
    ; __append("\n                </tr>\n\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}